import GameBoard from "./components/gameBoard/GameBoard";
function App() {
  return (
    <div className="App">
      <GameBoard />
    </div>
  );
}

export default App;
